// extracted by mini-css-extract-plugin
export default {"footer":"footer--kysPs"};